import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	Input,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { AuthSelector, CoreState } from "@obg/ngx.core";
import { coerceBoolean } from "@obg/ngx.global.evo";
import { Subscription } from "rxjs";
import { tap } from "rxjs/operators";

@Component({
	selector: "obg-dga-regulatory-items-container",
	templateUrl: "./dga-regulatory-items.container.html",
	styleUrls: ["./dga-regulatory-items.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class DgaRegulatoryItemsContainer implements OnInit, OnDestroy {
	@HostBinding("class.obg-dga-regulatory-items-container") hostCssClass = true;
	@HostBinding("class.obg-dga-regulatory-items-container-logged-in") loggedIn = false;

	@HostBinding("class.obg-dga-regulatory-items-container-ingame")
	@Input()
	@coerceBoolean()
	inGame = false;

	private data$$: Subscription | undefined;

	constructor(private store: Store<CoreState>) {}

	ngOnInit() {
		this.data$$ = this.store
			.pipe(
				AuthSelector.isAuthenticated$,
				tap((isAuth) => (this.loggedIn = isAuth))
			)
			.subscribe();
	}

	ngOnDestroy() {
		this.data$$?.unsubscribe();
	}
}
